console.log("Conversation Flow Loaded");

const FLOW = {

    CCTV: [

        {

            id: "location",

            question: "Where will you install the camera?",

            options: [

                "Home",

                "Office",

                "Shop",

                "Garden",

                "Warehouse"

            ]

        },

        {

            id: "wifi",

            question: "Does the location have Wi-Fi?",

            options: [

                "Yes",

                "No"

            ]

        },

        {

            id: "budget",

            question: "What is your budget?",

            options: [

                "Under ₹3000",

                "₹3000 - ₹6000",

                "Above ₹6000"

            ]

        }

    ]

};

function getConversationFlow(family){

    return FLOW[family] || [];

}